import { BaseStore } from 'core/base-store';
import { catchError, first, from, map, of } from 'rxjs';

import { UiService } from '@core/services/ui.services';
import { UserModel } from '@modules/administration/pages/users/user.model';
import { UserRepository } from '@modules/administration/pages/users/user.repository';

const itemInit: UserModel = new UserModel('');
type IState = {
  users: UserModel[];
};
const stateInit: IState = {
  users: [],
};

export class UserStore extends BaseStore<IState, UserModel> {
  constructor(uiService: UiService, private repository: UserRepository) {
    super(uiService, stateInit, itemInit);
  }

  loadList() {
    this.ui.loader.show();
    from(this.repository.getAll())
      .pipe(
        catchError(() => of([] as UserModel[])),
        map(users => {
          this._state.next({ users });
          this.ui.loader.hide();
        }),
        first(),
      )
      .subscribe();
  }

  async save() {
    try {
      const model = this.current;
      const entity = UserModel.build(model);
      if (!entity.id) {
        await this.repository.add(entity);
      } else {
        await this.repository.update(entity.id, entity);
      }
      this.ui.modal.close();
      this.loadList();
    } catch (e: any) {
      this.showValidationMessage(e.message);
    }
  }

  toggleActive(id: string) {
    this.repository.toggleActive(id);
    this.loadList();
  }
}
